module.exports = __webpack_public_path__ + "static/science-869e582ab1dccaf45f8393e6f171bb4a.jpg";